/* eslint eqeqeq: 0 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Modal from '../Modal';
import * as modal from '../../reducers/modalReducer';
import * as userReducer from '../../reducers/userReducer';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import styled from 'styled-components';
import { THIRD_COLOR } from '../../config/colors';
import { rootPageUri } from '../../config/uri';
import { startVerifyCode, startReRequestCode } from '../../actions/signup-sync';
import { CloseIcon } from '../../icons';

import './style.css'
import { pushWithQueryParams } from '../../services/uri';

class SignUpAuthConfirmModal extends Component {
  constructor(props) {
    super(props);
    this.codeInput = undefined;
    this.hiddenInput = undefined;
  }

  componentDidMount() {
    this.timer = null;
    if (this.codeInput) {
      this.codeInput.blur();
    }
    if (this.hiddenInput) {
      this.hiddenInput.focus();
    }
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }
  focusUsernameInputField = input => {
    input && input.focus();
    this.codeInput = input;
  };
  secondaryColor = '#'+this.props.secondaryColor;
   styles = {
      closeBtn: { position: 'absolute',  right: '10px', top: '10px', cursor: 'pointer' },
      closeIcon: { height: '35px',  width: '35px' },
      modal: {padding: '20px 0', overflow: 'hidden'},
      hiddenInput: {position: 'fixed', top: '-1000px'},
      textFieldInput: {
        fontFamily: 'Futura-Bold',
        padding: '0 0 0 29px',
        fontSize: '28px',
        fontWeight: '700',
        letterSpacing: '36px',
        color: this.secondaryColor,
      },
      greetings: {
        textAlign:'center',
        fontWeight: 700
      },
      field: {
        textAlign:'center',
        margin: '25px 0 40px'
      },
      labelStyle: {fontWeight:700}
    };
    state = {
        isOpen: true,
        authCode: '',
        left: 30,
        count: 0,
        resendAvailable: true,
        code: ''
    }
    isSignupRequest = false;
    onCloseRequest = () => {
        this.setState({
            isOpen: false
        })
    }

    handleSignup = () => {
        this.isSignupRequest = true;
        this.props.openSignUpForm();
    }
    onAuthCode = (e) => {
      this.setState({
        authCode: e.target.value
      })
    }
    handleAuthClick = () => {
      // verify code in the server
      this.props.verifyCode(this.props.user.tempUser.id, this.state.authCode);
    }

    isAuthCode = () => {
      return this.state.authCode.length === 5
    }

    getColor = (num) => {
      return this.state.authCode.length >= num - 1 ? this.secondaryColor : THIRD_COLOR;
    }

    requestCode = (customerId) => {
      clearInterval(this.interval);
      this.setTimer();
      this.props.reRequestCode(customerId);
    };

    setTimer = () => {
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        if (this.state.left === 0) {
          clearInterval(this.interval);
          const state = this.state.count < 5;
          this.setState({
            ...this.state,
            resendAvailable: state,
            count: this.state.count + 1,
            left: 30
          });
          return;
        }
        this.setState({
          ...this.state,
          left: this.state.left - 1,
          resendAvailable: false,
        });
      }, 1000);
    };
    renderResend = () => {
      const customerId = this.props.user.tempUser.id;
      const placeholder = this.state.count < 5 ? (<div>You can resend code in {this.state.left} seconds</div>) : (<div>Only 5 resends available</div>);
      const title = this.state.resendAvailable ? (<div>You can <span style={{cursor: 'pointer'}}><Link onClick={() => this.requestCode(customerId)}>resend</Link></span> code</div>) : placeholder;
      const header = this.props.signup.showResend ? <div>You entered invalid code</div> : '';
      return (
        <ResendError>
          {header}
          {title}
        </ResendError>
      );
    }

  handleExit = () => {
    this.props.hideModal();
    this.props.openMainPage();
  }

  handleInputEnterPress = (e) => {
    if ((e.key === 'Enter' || e.key == '13') && this.state.code.length === 5) {
      this.handleAuthClick();
    }
  }
  handleCodeInput = (e) => {
    e.target.value = Math.max(0, parseInt(e.target.value, 10) ).toString().slice(0,5);
    this.setState({
      code: e.target.value
    });
    if (this.props.is_iPhone && e.target.value.length === 5) {
      this.codeInput.blur();
      this.hiddenInput.focus();
    }
  }

  render() {
    const addClass = this.state.code.length === 5 ? 'code-input' : '';
    return (
      <Modal style={this.styles.modal} wrapperTop={'250px'} overlayTop={0} closeOnOverlayClick={false} closeOnOutsideClick={false} isOpened={this.state.isOpen} onClose={this.onCloseRequest}>
          <div className="signup-auth-confirm">
            <div style={this.styles.closeBtn} onClick={this.handleExit}>
              <CloseIcon color="#afafb1" style={this.styles.closeIcon} />
            </div>
            <div style={this.styles.greetings}>
              <HeaderDiv color={'#'+this.props.secondaryColor}>
                <div>PLEASE ENTER</div>
                 <div>AUTHENTICATION CODE</div>
              </HeaderDiv>
            </div>

            <div style={this.styles.field}>
              <TextField
                onChange={this.onAuthCode}
                type="number"
                name="authcode"
                className={addClass}
                max={5}
                onInput={this.handleCodeInput}
                onKeyPress={(e) => this.handleInputEnterPress(e)}
                style={{width: '290px'}}
                ref={this.focusUsernameInputField}
                inputStyle={this.styles.textFieldInput}
                underlineStyle={{border: 'none' }}
                value={this.state.authCode}
              />
              <input
                type="text"
                ref={e => this.hiddenInput = e}
                onKeyPress={(e) => this.handleInputEnterPress(e)}
                style={this.styles.hiddenInput}
              />
            </div>

            <PinBorder>
              <PinDiv color={this.getColor(1)}/><PinDiv color={this.getColor(2)}/><PinDiv color={this.getColor(3)}/><PinDiv color={this.getColor(4)} /><PinDiv color={this.getColor(5)}/>
            </PinBorder>
            {this.renderResend()}
            <div>
              <RaisedButton
                disabled={!this.isAuthCode()}
                onClick={this.handleAuthClick}
                backgroundColor={`#` + this.props.secondaryColor}
                labelColor="#FFF"
                label="Submit"
                labelStyle={this.styles.labelStyle}
              />
            </div>
          </div>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    tempUser: state.user.tempUser,
    primaryColor: state.config.primaryColor,
    secondaryColor: state.config.secondaryColor,
    user: state.user,
    signup: state.signup,
    is_iPhone: state.config.is_iPhone,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    openMainPage: () => dispatch(pushWithQueryParams(rootPageUri)),
    setUser: (user) => dispatch(userReducer.setUser(user)),
    hideModal: () => dispatch(modal.hideModal()),
    openSignUpForm: () => dispatch(modal.openModal({
      modalType: 'SIGNUP_FORM',
      modalProps: {}
    })),
    openPasswordForm: () => dispatch(modal.openModal({
      modalType: 'PASSWORD_FORM',
      modalProps: {}
    })),
    verifyCode: (customerId, code) => dispatch(startVerifyCode(customerId, code)),
    reRequestCode: (customerId) => dispatch(startReRequestCode(customerId)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SignUpAuthConfirmModal);

const HeaderDiv = styled.div `
  color: ${props => props.color};
  font-size: 24px;
  font-weight: 700;
  font-family: 'Futura-Bold';
  text-align: center;
`;

const PinDiv = styled.div `
  width: 46px;
  height: 0;
  border-bottom: 2px solid ${props => props.color};
`;

const PinBorder = styled.div `
  margin-top: -42px;
  margin-bottom: 33px;
  width: 256px;
  display: flex;
  justify-content: space-between;
`;

const ResendError = styled.div `
  border: 1 px solid black;
  text-align: center;
  margin-bottom: 32px;
`;

const Link = styled.span `
  color: #8bc027;
  font-family: 'Futura-Bold';
`;



// WEBPACK FOOTER //
// ./src/components/SignUpAuthConfirmModal/SignUpAuthConfirmModal.jsx